export default {
	quoteList: [],
	quoteSearchList: [],
	quoteSearchListSet: [],
    quotesLoaded: false,
    soLoaded: false,
	specList: [],
	tenderList: [],
    rfcList: [],
    rfcSearchList: [],
	productSalesList: [],
	productSalesSubList: [],
	productSalesProducts: [],
	statusList: [],
	soStatusList: [],
	rfcStatusList: [],
    rfcHistory: [],
	rfcOriginators: [],
	rfcCustomers: [],
	rfcStatusses: [],
	objStatusEdit: [],
	objRfcStatusEdit: [],
	objQuoteSettings: [],
	objSoSettings: [],
	objUserInfo: [],
	objQuoteHistory: '',
	objDateHistory: '',
	objTenderFilters: {
		customer_company: 0,
		customer_user: 0,
		originator: 0,
		project_status: "All",
		project_tender_status: "*",
		project_type: "*",
		quote_status: ["None"],
		tender_status: ["*"]
	},
	objSalesFilters: {
		customer_company: 0,
		customer_user: 0,
		date_from: 'null',
		date_to: 'null',
		originator: 0,
		product_tender_status: "*",
		project: 0,
		quote_status: "None",
		tender_status: "*"
	},
    discountList: [],
	discountRequestors: [],
	discountAuthorisers: [],
	productSaleRange: '',
	productSalesSelectProducts: [],
	singleQuoteData: [],
	objDiscountReportFilters: {
		'startDate': window.localStorage.discountStartDate != null ? window.localStorage.discountStartDate : '',
		'endDate': window.localStorage.discountEndDate != null ? window.localStorage.discountEndDate : '',
		'requestor': window.localStorage.discountRequestor != null ? window.localStorage.discountRequestor : '',
		'authorizer': window.localStorage.discountAuthoriser != null ? window.localStorage.discountAuthoriser : ''
	},
	objRfcFilters: {
		'startDate': window.localStorage.rfcStartDate != null ? window.localStorage.rfcStartDate : '',
		'endDate': window.localStorage.rfcEndDate != null ? window.localStorage.rfcEndDate : '',
		'originator': window.localStorage.rfcOriginator != null ? window.localStorage.rfcOriginator : '',
		'customer': window.localStorage.rfcCustomer != null ? window.localStorage.rfcCustomer : '',
		'status': window.localStorage.rfcStatus != null ? window.localStorage.rfcStatus : '',
		'srNumber': window.localStorage.rfcSrNumber != null ? window.localStorage.rfcSrNumber : '',
		'cnNumber': window.localStorage.rfcCnNumber != null ? window.localStorage.rfcCnNumber : '',
		'rfcNumber': window.localStorage.rfcRfcNumber != null ? window.localStorage.rfcRfcNumber : ''
	},
	objProductSalesFilters: {
		'startDate': window.localStorage.psStartDate != null ? window.localStorage.psStartDate : '',
		'endDate': window.localStorage.psEndDate != null ? window.localStorage.psEndDate : '',
		'quoteStatus': window.localStorage.psQuoteStatus != null ? window.localStorage.psQuoteStatus : '',
		'quoteTenderStatus': window.localStorage.psQuoteTenderStatus != null ? window.localStorage.psQuoteTenderStatus : '',
		'productTenderStatus': window.localStorage.psProductTenderStatus != null ? window.localStorage.psProductTenderStatus : '',
		'originator': window.localStorage.psOriginator != null ? window.localStorage.psOriginator : '',
		'customer': window.localStorage.psCustomer != null ? window.localStorage.psCustomer : '',
		//'company': window.localStorage.psCompany != null ? window.localStorage.psCompany : ''

	},
	psStatusses: [],
	psTenderStatusses: [],
	psProductTenderStatusses: [],
	psOriginators: [],
	psCustomers: [],
	objQuoteFilters: {
		'startDate': window.localStorage.qStartDate != null ? window.localStorage.qStartDate : [],
		'endDate': window.localStorage.qStartDate != null ? window.localStorage.qStartDate : [],
		'regions': window.localStorage.qStartDate != null ? window.localStorage.qStartDate : [],
		'originators': window.localStorage.qStartDate != null ? window.localStorage.qStartDate : [],
		'status': window.localStorage.qStartDate != null ? window.localStorage.qStartDate : [],
		'companies': window.localStorage.qStartDate != null ? window.localStorage.qStartDate : [],
		'users': window.localStorage.qStartDate != null ? window.localStorage.qStartDate : [],
		'projects': window.localStorage.qStartDate != null ? window.localStorage.qStartDate : [],
		'specifiers': window.localStorage.qStartDate != null ? window.localStorage.qStartDate : []
	},
    objSalesOrderFilters: [],
	quoteSettings: [],
	availableReps: [],
	currencyRate: '',
	specStatusList: [],
	salesOrderList: [],
	salesOrderListFilter: [],
	salesOrderVendors: [],
	salesOrderListAll: [],
	salesOrderStatusses: [],
	soColumns: '',
  quoteReportLoaded: false,
	stockAvailability: '',
	isLoaded: false,
  quoteUsers: [],
  columnsLoading: false,
  columnsSorted: false,
  newReportFilters: '',
  dashboardData: '',
  filterNeedsReload: false,
  filterNeedsReloadSo: false,
  totalQuoteRecords: 0,
  excelLoading: false,
  departmentStatusFilter: 0,
  surveyFiles: [],
  systemSettings: [],
  surveyList: [],
  surveyListQuotes: [],
  surveyProductCodes: [],
  quoteLinks: [],
  editLoading: false,
  soFilters: [],
  soExcelLoading: false,
  summaryLoading: false,
  soReps: [],
  statusEdit: false,
  SummaryStatusList: [],
  SummaryRoleList: [],
  convertLoading: false,
  notificationHistoryLoaded: false,
  notificationHistory: [],
  allFilters: [],
  initialFiltersLoaded: false,
  summaryFilterLoad: false,
  topTabsCount:[],
  totalPending: false,
  Search_Set_Selected_Tab: null,
  selectedTabWithQuotes: '',
  calculatorFilters: [],
  spineLoading: false,
  storeAudits: [],
  vendorListCodes: [],
  archivedQuotes: [],
  surveyCalculators: [],
  surveyListProcess: [],
  quoteApis: [],
  installationDateSaved: false,
  quotesLite: [],
  quotesLiteFilters: [],
  quoteSingle: [],
  filtersLoading: false,
  quoteLiteLoaded: false,
  quoteLiteContentClick: false,
  quoteLiteSingle: [],
  quoteLiteContentLoaded: false,
  quoteRepsLite: [],
  liteColumns: [],
  liteFilterLoaded: false
}
